<template>
  <div class="user-agreement">
    <iframe 
      src="https://api2.ts960.com/sztx/sztx-user.html" 
      frameborder="0"
      width="100%" 
    ></iframe>
  </div>
</template>

<script>
export default {
  methods:{
  },
  mounted(){
  }
}
</script>

<style lang="less" scoped>
  .user-agreement{
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    iframe{
      height: 2200px;
    }
  }
@media screen and (max-width: 768px){
  .user-agreement{
    padding: 0 20px;
  }
  .user-agreement iframe{
      height: 4170px;
    }
}
</style>